const firebaseConfig = {
  apiKey: "AIzaSyAeRYddCm12GmIXLgOlf1DhCLd4ysFAHTE",
  authDomain: "launchpad-169908.firebaseapp.com",
  databaseURL: "https://launchpad-169908.firebaseio.com",
  projectId: "launchpad-169908",
  storageBucket: "launchpad-169908.appspot.com",
  messagingSenderId: "266978295742",
  appId: "1:266978295742:web:e6ab749c048c374b34c3ef"
};
exports.config = firebaseConfig;



// WEBPACK FOOTER //
// ./src/config/firebase_config.js